module.exports = __webpack_public_path__ + "img/alert3b_v2.622e0892.svg";